export var StorageGatewayStatus;
(function (StorageGatewayStatus) {
    StorageGatewayStatus["STORAGE_GATEWAY_STATUS_UNSPECIFIED"] = "STORAGE_GATEWAY_STATUS_UNSPECIFIED";
    StorageGatewayStatus["STORAGE_GATEWAY_STATUS_HEALTHY"] = "STORAGE_GATEWAY_STATUS_HEALTHY";
    StorageGatewayStatus["STORAGE_GATEWAY_STATUS_UNHEALTHY"] = "STORAGE_GATEWAY_STATUS_UNHEALTHY";
    StorageGatewayStatus["STORAGE_GATEWAY_STATUS_PENDING"] = "STORAGE_GATEWAY_STATUS_PENDING";
})(StorageGatewayStatus || (StorageGatewayStatus = {}));
